import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ImportService } from '../../../../../ongoing/src/lib/services/import/import.service';
import { map, tap, catchError } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { TrackingSegmentService } from '@unico-people/shared/data-access-tracking-segment';
import { SegmentTrackHistory } from '@unico-people/shared/enums/utils-enums';

interface StatusProtocol {
  message: string;
  class: string;
}

@Component({
  selector: 'unico-people-employee-status',
  templateUrl: './employee-processing-status.component.html',
  styleUrls: ['./employee-processing-status.component.scss']
})

export class EmployeeProcessingStatusComponent implements OnInit {
  @Input() set openMenu(open: boolean) { this.showSidebar = open; }
  @Input() protocolNumber: string;

  @Output() menu = new EventEmitter<boolean>();

  error$ = new Subject<any>();
  list$: Observable<any>;
  statusProtocol$: Observable<any>;
  showSidebar = false;
  page = 1;
  sortOrder = "desc";
  limit = 10;
  total = 0;
  displayedColumns: string[] = ['fileName', 'date', 'imported', 'protocol', 'status', 'actions'];

  constructor(
    private importService: ImportService,
    public route: ActivatedRoute,
    public router: Router,
    private segment: TrackingSegmentService
  ) {}

  ngOnInit(): void {
    this.getListStatusProcessingImport(
      {page: 1, pageSize: 10, sortOrder: 'desc'}
    )
    this.segment.page(SegmentTrackHistory.page_view_history);
  }

  toggleMenu(): void {
    this.showSidebar = !this.showSidebar;
    this.menu.emit(this.showSidebar);
  }

  getPage(page: number): void {
    this.page = page;
    this.router.navigate(['/processing-status'], {
      queryParams: { page: page, pageSize: this.limit, sortOrder: this.sortOrder}
    });
    this.getListingParams();
  }

  getPageForLimit(limit: number): void {
    this.limit = limit;
    this.page = 1;
    this.router.navigate(['/processing-status'], {
      queryParams: {page: this.page, pageSize: this.limit, sortOrder: this.sortOrder }
    });
    this.getListingParams();
  }

  getListingParams(): void {
    this.route.queryParams.subscribe(params => {
      this.getListStatusProcessingImport(params) ;
    });
  }

  /**
   * Import protocol status return
   */
  statusProcessingProtocol(protocolNumber): void {
    this.segment.track(SegmentTrackHistory.click_button_action_eye);

    this.statusProtocol$ = this.importService.getStatusProcessingProtocol(
      protocolNumber
    ).pipe(
      map(statusImport => statusImport?.body),
      catchError(err => {
        this.error$.next(err);
        return of();
      })
    );
    this.toggleMenu();
  }

  /**
   * Import process history listing
   */
  getListStatusProcessingImport(params: object) : void {
    this.list$ = this.importService.getListStatusProcessingImport(params)
    .pipe(
      tap(res => (this.total = res?.body.paginator.totalRows)),
      map(listImport => listImport.body?.data),
      catchError(err => {
        this.error$.next(err);
        return of();
      })
    );
  }

  /**
   * Request that returns url for error file download
   */
  downloadStatusError(protocolNumber): void {
    this.segment.track(SegmentTrackHistory.click_button_report_error);

    this.importService.getErrorProtocol(protocolNumber)
    .subscribe(res => {
        let url = res.body.url;
        let a = document.createElement('a');
        a.href = url;
        a.download = res.body.url;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      }
    )
    catchError(err => {
      this.error$.next(err);
      return of();
    })
  }

  trackHistory(track: string): void {
    const trackHistory = {
      import_empty: SegmentTrackHistory.click_button_import_empty_page_history,
      import_history: SegmentTrackHistory.click_button_import_history,
    }
    this.segment.track(trackHistory[track]);
  }

  /**
   * Label mapping list
   */
  statusProtocolLabel(status: string): StatusProtocol | null {
    switch (status) {
      case 'NEW':
        return {
          message: 'Na fila',
          class: '--new '
        };

      case 'FINISHED':
        return {
          message: 'Processado',
          class: '--finished'
        };

      case 'IN_PROGRESS':
      return {
        message: 'Em processamento',
        class: '--in-progress'
      };

      case 'FINISHED_WITH_ERRORS':
      return {
        message: 'Processado com erros',
        class: '--finished-with-errors'
      };

      default:
        return {
          message: '',
          class: ''
        };
    }
  }
}
